import { Loader } from "@transfr-inc/dashboard-components";

import { useAiCurriculumPolling } from "@queries/ai-curriculum";

import "./ai-loading.step.scss";

export const AiLoadingStep = ({
  orgCode,
  sessionId,
  targetStatus,
  runKey,
  label = "Processing…",
  subtext,
  onComplete,
  onError,
}) => {
  useAiCurriculumPolling(orgCode, sessionId, {
    targetStatus,
    runKey,
    onComplete,
    onError,
  });

  return (
    <div className="ai-loading-step">
      <Loader />
      <h3 className="ai-loading-step__label">{label}</h3>
      {subtext && <p className="ai-loading-step__subtext">{subtext}</p>}
    </div>
  );
};
